import { render } from "./CobaltSidebar.vue?vue&type=template&id=5602bb78"
import script from "./CobaltSidebar.vue?vue&type=script&lang=js"
export * from "./CobaltSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__